import Groupings from 'Common/Constants/Groupings';

const baseExport = [
    { field: 'year', label: 'Year'},
    { field: 'description', label: 'Description'},
    { field: 'type', label: 'Type'},
    { field: 'template', label: 'Template'},
    { field: 'appointmentId', label: 'Appointment ID'},
    { field: 'contractGrouping', label: 'Contract Group'},
    { field: 'appointee.title', label: 'Title'},
    { field: 'appointee.initials', label: 'Initials'},
    { field: 'appointee.surname', label: 'Surname'},
    { field: 'appointee.ni', label: 'NI number'},
    { field: 'appointee.appointeeId', label: 'Appointee ID'},
    { field: 'daysRequired', label: 'Days Required'},
    { field: 'daysOwnTime', label: 'Days Own Time'},
];

const appointmentGroups = [
    ...baseExport,
    { field: 'code', label: 'Appointment Group Code'},
    { field: 'team', label: 'Appointment Group Name'},
    { field: 'notes', label: 'Comment'},
    { field: 'appointmentGroup.markingCode', label: 'Marker Code'}
];

const invigilator = [
    ...baseExport,
    { field: 'code', label: 'Centre Code'},
    { field: 'team', label: 'Centre Name'},
    { field: 'invigilator.centreId', label: 'Centre ID'},
    { field: 'notes', label: 'Position Number'},
];

const verifier = [
    ...baseExport,
    { field: 'code', label: 'Moderation Group ID'},
    { field: 'team', label: 'Moderation Group Name'},
    { field: 'verifier.centralModerationFlag', label: 'Central Moderation Flag'},
    { field: 'verifier.visitingModerationFlag', label: 'Visiting Moderation Flag'}
];

const adhoc = [
    ...baseExport,
    { field: 'daysGranted', label: 'Days Granted' },
    { field: 'code', label: 'Appointment Group Code'},
    { field: 'team', label: 'Appointment Group Name'},
    { field: 'appointmentGroupId', label: 'Appointment Group ID'},
    { field: 'contract.contractTypeId', label: 'Contract Type Id'},
    { field: 'contract.endDate', label: 'Contract End Date'},
    { field: 'contract.releaseDate', label: 'Contract Release Date' },
];

const exportSchemas = {
    [Groupings.AppointmentGroups]: appointmentGroups,
    [Groupings.Invigilator]: invigilator,
    [Groupings.Verifier]: verifier,
    [Groupings.Adhoc]: adhoc
};

const sortFields = {
    [Groupings.AppointmentGroups]: ['Appointment Group Name', 'Surname', 'Initials', 'NI number'],
    [Groupings.Invigilator]: ['Centre Name', 'Surname', 'Initials', 'NI number'],
    [Groupings.Verifier]: ['Moderation Group Name', 'Surname', 'Initials', 'NI number'],
    [Groupings.Adhoc]: ['Appointment Group Name', 'Surname', 'Initials', 'NI number']
};

const sortOrders = ['asc','asc','asc','asc'];

const getExportSchema = grouping => exportSchemas[grouping];

const getSortFields = grouping => sortFields[grouping];

export  { getExportSchema, getSortFields, sortOrders };
